import { deviceType } from 'react-device-detect';
import type { TabletOrMobileOrDesktop } from './types';

export const getClientDeviceType = (): TabletOrMobileOrDesktop => {
  if (deviceType === 'mobile') {
    return 'mobile';
  }

  if (deviceType === 'tablet') {
    return 'tablet';
  }

  return 'desktop';
};
